import React, { Component } from "react";
import MainLayout from "../../components/layouts/main";
import Constants from "../../data/constants";
import Data from "../../data/data";
import PrimaryActionButton from "../../components/PrimaryActionButton";
import EmptyState from "../../components/EmptyState";
import { AppWindow, Lock } from "lucide-react";
import { motion } from "framer-motion";
import {
  Card,
  Avatar,
  Button,
  Row,
  Col,
  List,
  Modal,
  Tooltip,
  Space,
  Popover,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  SettingOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
} from "../../actions";
import PopupManager from "../../managers/PopupManager";
import { useParams, useHistory } from "react-router-dom";
import PermissionManager from "../../managers/PermissionManager";
import WidgetInstanceListPage from "../WidgetInstanceList";
import colors from "../../config/Colors";
import { SERVER_CONFIG } from "../../Config";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const { Meta } = Card;
const { confirm } = Modal;

const WidgetPage = (props) => {
  const history = useHistory();
  const params = useParams();
  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.widgetPage || PRO_TRANSLATIONS.en.widgetPage;
  return (
    <WidgetPageClass
      preSelectedWidgetID={params.Widgetid}
      langT={t}
      {...props}
    ></WidgetPageClass>
  );
};

class WidgetPageClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widgetDatas: [],
      selectedWidget: null,
      selectedTimeline: null,
      rand: Math.random(),
    };
  }

  componentDidMount() {
    console.log("WIDGET MOUTH");
    this.updateWidgetListData();
  }

  componentDidUpdate = (newProps) => {
    // if ("selectedBrandData" in newProps && this.props.selectedBrandData !== newProps.selectedBrandData) {
    if (this.props.selectedBrandData !== newProps.selectedBrandData) {
      this.updateWidgetListData();
    }

    // Sidebar re-click: user clicked Widget menu while already on this page
    const prevPageId = newProps.selectedPage?.id;
    const currPageId = this.props.selectedPage?.id;
    if (
      currPageId === Constants.WIDGET_PAGE &&
      prevPageId === Constants.WIDGET_PAGE &&
      newProps.selectedPage !== this.props.selectedPage &&
      this.state.selectedWidget
    ) {
      this.setState({ selectedWidget: null });
    }
  };

  updateWidgetListData = () => {
    const {
      requestServerGet,
      userdata,
      selectedBrandData,
      preSelectedWidgetID = -1,
    } = this.props;

    // if (!selectedBrandData)
    //     return;

    var optionalParams = {};

    if (selectedBrandData) {
      optionalParams = { brandid: selectedBrandData.BrandID };
    }
    requestServerGet(
      "get_widgets",
      { ...optionalParams },
      null,
      (response) => {
        console.log("get_widgets " + JSON.stringify(response.data));
        this.setState({ widgetDatas: response.data }, () => {
          if (preSelectedWidgetID > -1) {
            const cData = this.state.widgetDatas.find((data) => {
              return `${data.WidgetID}` === `${preSelectedWidgetID}`;
            });

            if (cData) {
              this.setState({ selectedWidget: cData });
            }
          }
        });
      },
      userdata.token,
    );
  };

  onWidgetClicked = (data) => {
    // console.log("onWidgetClicked")
    this.setState({ selectedWidget: data }, () => {
      // this.updateTimelineListData();
    });
  };
  onWidgetContentClicked = (data) => {
    // console.log("onWidgetContentClicked")
    this.setState({ selectedTimeline: data });
  };

  onBackOffWidgetContent = () => {
    this.setState({ selectedWidget: null });
  };
  onBackOffWidgetContentChannel = () => {
    this.setState({ selectedTimeline: null });
  };

  showConfirm = (data, callback) => {
    const { selectPage, globalSearch, usertoken, requestServerPost } =
      this.props;
    const t = this.props.langT || PRO_TRANSLATIONS.en.widgetPage;

    confirm({
      title: t.deleteConfirm,
      icon: <ExclamationCircleOutlined />,
      onOk() {
        requestServerPost(
          "delete_Widget",
          { Widgetid: data.WidgetID },
          {},
          () => {
            callback();
          },
          usertoken,
        );
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };

  launchCreateWidget = () => {
    PopupManager.launchCreateWidgetPopup(this.updateWidgetListData);
  };
  launchEditWidget = (data) => {
    PopupManager.launchEditWidgetPopup(data, this.updateWidgetListData);
  };

  renderWidgetPreview = (widgetData) => {
    return (
      <div
        style={{
          width: "200px",
          height: "200px",
          padding: "0px",
          borderRadius: "0px",
        }}
      >
        <iframe
          onLoad={this.onIFrameLoaded}
          id="widget-iframe"
          frameBorder="none"
          style={{ height: "100%", width: "100%" }}
          src={`${SERVER_CONFIG.SERVER_URI}widgets/${widgetData.WidgetKey}/preview?random=${this.state.rand}`}
        ></iframe>
      </div>
    );
  };

  renderWidgetList = () => {
    const editPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_Widget,
      PermissionManager.PERMISSION_TYPE_EDIT,
    );
    const deletePermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_Widget,
      PermissionManager.PERMISSION_TYPE_DELETE,
    );
    const t = this.props.langT || PRO_TRANSLATIONS.en.widgetPage;

    if (this.state.widgetDatas.length === 0) return null;

    const { requestServerGet, userdata, selectedBrandData, globalSearch } =
      this.props;
    return this.state.widgetDatas
      .filter((data) => {
        return data.WidgetName.toLocaleLowerCase().includes(
          globalSearch.toLocaleLowerCase(),
        );
      })
      .map((data) => {
        const firstLetter =
          data.WidgetName.length > 0 ? data.WidgetName.charAt(0) : "";
        return (
          <Col style={{ padding: "8px" }}>
            <div className="widget-card">
              {/* Inner: clips image to rounded corners — isolated from the transform */}
              <div
                style={{
                  borderRadius: 16,
                  overflow: "hidden",
                  background: "#fff",
                }}
              >
                <div style={{ background: "#fff" }}>
                  <Popover
                    content={this.renderWidgetPreview(data)}
                    placement="right"
                    title=""
                    trigger="hover"
                  >
                    <div
                      onClick={() => this.onWidgetClicked(data)}
                      style={{ lineHeight: 0, cursor: "pointer" }}
                    >
                      <img
                        style={{
                          width: "100%",
                          display: "block",
                          aspectRatio: "4/3",
                          objectFit: "cover",
                        }}
                        alt="cover"
                        src={data.WidgetCover}
                      />
                    </div>
                  </Popover>
                  <div
                    style={{
                      padding: "10px 14px",
                      fontWeight: 600,
                      fontSize: 14,
                      color: "#0f172a",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textAlign: "center",
                    }}
                  >
                    {data.WidgetName}
                  </div>
                  {(editPermission || deletePermission) && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 16,
                        padding: "6px 14px 10px",
                        borderTop: "1px solid #f1f5f9",
                        marginTop: 6,
                        lineHeight: 1,
                      }}
                    >
                      {editPermission && (
                        <Tooltip title={t.edit}>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              lineHeight: 1,
                              cursor: "pointer",
                            }}
                            onClick={() => this.launchEditWidget(data)}
                          >
                            <EditOutlined
                              style={{
                                fontSize: 16,
                                color: "#64748b",
                                display: "block",
                              }}
                            />
                          </span>
                        </Tooltip>
                      )}
                      {deletePermission && (
                        <Tooltip title={t.delete}>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              lineHeight: 1,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              this.showConfirm(data, this.updateWidgetListData);
                            }}
                          >
                            <DeleteOutlined
                              style={{
                                fontSize: 16,
                                color: "#64748b",
                                display: "block",
                              }}
                            />
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Col>
        );
      });
  };

  onTimelineSelected = (timelineData) => {
    this.setState({ selectedTimeline: timelineData });
  };

  localStepBack = (destination) => {
    console.log("localStepBack " + destination);
    switch (destination) {
      case "Widget":
        this.setState({ selectedWidget: null });
        break;
    }
  };

  getWidgetInstanceListView = () => {
    return (
      <WidgetInstanceListPage
        localStepBack={this.localStepBack}
        onBackClicked={() => {
          this.setState({ selectedWidget: null });
        }}
        preventDefaultStepBack={true}
        onTimelineSelected={this.onTimelineSelected}
        selectedWidget={this.state.selectedWidget}
      ></WidgetInstanceListPage>
    );
  };
  getWidgetView = () => {
    const createPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_Widget,
      PermissionManager.PERMISSION_TYPE_CREATE,
    );
    const t = this.props.langT || PRO_TRANSLATIONS.en.widgetPage;
    return (
      <MainLayout
        id={Constants.WIDGET_PAGE}
        style={{ padding: 20 }}
        renderBreadCrumb={() => {
          return [
            <span
              style={{ fontSize: 14, fontWeight: 500, color: "#94a3b8", padding: "4px 8px", lineHeight: "22px" }}
            >
              {t.pageTitle}
            </span>,
          ];
        }}
      >
        {/* Page header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#fff",
            borderRadius: 16,
            padding: "20px 24px",
            border: "1px solid #e8ecf3",
            marginBottom: 20,
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div
              style={{
                width: 52,
                height: 52,
                borderRadius: 14,
                flexShrink: 0,
                background: "linear-gradient(135deg, #eef2ff, #e0e7ff)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AppWindow size={26} color="#6366f1" />
            </div>
            <div>
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 800,
                  color: "#0f172a",
                  lineHeight: 1.2,
                }}
              >
                {t.pageTitle}
              </div>
              <div style={{ fontSize: 13, color: "#94a3b8", marginTop: 3 }}>
                {t.subtitle}
              </div>
            </div>
          </div>
          {createPermission ? (
            <PrimaryActionButton onClick={this.launchCreateWidget}>
              {t.createWidget}
            </PrimaryActionButton>
          ) : null}
        </div>
        <div style={{ width: "100%", paddingBottom: 12 }}>
          {this.state.widgetDatas.length === 0 ? (
            <EmptyState
              icon={<Lock size={26} color="#64748b" />}
              iconBg="linear-gradient(135deg, #f1f5f9, #e2e8f0)"
              title={t.emptyTitle}
              description={t.emptyDesc}
            />
          ) : (
            <Row gutter={[40, 20]} justify="center">
              {this.renderWidgetList()}
            </Row>
          )}
        </div>
      </MainLayout>
    );
  };

  render() {
    var view = this.getWidgetView();

    if (this.state.selectedWidget !== null) {
      view = this.getWidgetInstanceListView();
    }

    return view;
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBrandData: state.selectedBrandData,
    selectedPage: state.selectedPage,
  };
};

export default connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
})(WidgetPage);
